import axios from 'axios';
const api_url = process.env.VUE_APP_API_VIDA_URL;
import usersUtils from '../utils/user';

export default {
  async getBrokersPreRegisterFilters() {
    try {
      const response = await axios.get(
        `${api_url}/pre-registered-brokers/filters`,
        {
          headers: {
            Authorization: `Bearer ${usersUtils.getUserAuthToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getBrokersPreRegisterById(id) {
    try {
      const response = await axios.get(
        `${api_url}/pre-registered-brokers/${id}`,
        {
          headers: {
            Authorization: `Bearer ${usersUtils.getUserAuthToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getBrokersPreRegisterExportByFilters(filters) {
    try {
      const response = await axios.get(
        `${api_url}/pre-registered-brokers/export`,
        {
          headers: {
            Authorization: `Bearer ${usersUtils.getUserAuthToken()}`,
          },
          params: filters,
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getBrokersPreRegister(filters) {
    try {
      const response = await axios.get(`${api_url}/pre-registered-brokers`, {
        headers: {
          Authorization: `Bearer ${usersUtils.getUserAuthToken()}`,
        },
        params: filters,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async checkBrokerExistsByCnpj(cnpj) {
    try {
      const response = await axios.get(
        `${api_url}/pre-registered-brokers/check-exists?cnpj=${cnpj}`,
        {
          headers: {
            Authorization: `Bearer ${usersUtils.getUserAuthToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async update(id, data) {
    try {
      const response = await axios.patch(
        `${api_url}/pre-registered-brokers/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${usersUtils.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      const errors = error.response.data.errors;

      const errorsIsMessage = Array.isArray(errors)
        ? 'Falha ao salvar'
        : errors;
      throw errors !== 'Bad Request' ? errorsIsMessage : null;
    }
  },

  async saveObservations(id, data) {
    try {
      const response = await axios.patch(
        `${api_url}/pre-registered-brokers/${id}/observations`,
        data,
        {
          headers: {
            Authorization: `Bearer ${usersUtils.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      const errors = error.response.data.errors;

      throw errors !== 'Bad Request'
        ? Array.isArray(errors)
          ? 'Falha ao salvar'
          : errors
        : null;
    }
  },

  async approve(data) {
    try {
      const response = await axios.patch(
        `${api_url}/pre-registered-brokers/approve`,
        data,
        {
          headers: {
            Authorization: `Bearer ${usersUtils.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      const errors = error.response.data.errors;

      throw errors !== 'Bad Request' ? errors : null;
    }
  },

  async manualApprove(id) {
    try {
      const response = await axios.patch(
        `${api_url}/pre-registered-brokers/${id}/manual-approve`,
        null,
        {
          headers: {
            Authorization: `Bearer ${usersUtils.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      const errors = error.response.data.errors;

      throw errors !== 'Bad Request' ? errors : null;
    }
  },

  async upload(data) {
    try {
      const response = await axios.post(`${api_url}/files`, data, {
        headers: {
          Authorization: `Bearer ${usersUtils.getUserAuthToken()}`,
        },
      });
      return response.data;
    } catch (error) {
      const errors = error.response.data.errors;

      throw errors !== 'Bad Request' ? errors : null;
    }
  },

  async downloadDocuments(id) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/pre-registered-brokers/${id}/documents`,
        {
          headers: {
            Authorization: `Bearer ${usersUtils.getUserAuthToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
